import React from "react"
import { useEffect, useState } from "react"
import { useLocation, useNavigate, useParams } from "react-router-dom";
import store, { type RootState } from "../../../global/config/store.ts"
import { Box, Button, } from "@mui/material";
import { setLoadingFalse, setLoadingTrue } from "../../../global/config/Action/loadingActions.ts"
import imageCompression from "browser-image-compression"
import { CustomUploadProfilePic } from "../../../apiService/Core/CustomUploadProfilePic.tsx"
import { toast } from "react-toastify";
import { Upload } from "@mui/icons-material";
import { ApicreateAirTasker, ApiupdateAirTasker } from "../../../apiService/Core/Apicall.tsx";

const AirTasker: React.FC = () => {

    const { mode = "add", id } = useParams();
    const location = useLocation();
    const navigate = useNavigate();
    const shopperDetails = location?.state?.shopperDetails;

    const [formData, setFormData] = useState({
        firstName: "",
        lastName: "",
        emailId: "",
        contactNo: "",
        city: "",
        dob: "",
        gender: "",
        isAirTasker: true,
        driving_licence: ""
    })
    const [licenceImage, setlicenceImage] = useState<string | null>(null)
    useEffect(() => {
        if (mode === "update" && shopperDetails) {
            setFormData({
                firstName: shopperDetails.firstName || "",
                lastName: shopperDetails.lastName || "",
                emailId: shopperDetails.emailId || "",
                contactNo: shopperDetails.contactNo || "",
                city: shopperDetails.city || "",
                dob: shopperDetails.dob || "",
                gender: shopperDetails.gender || "",
                isAirTasker: true,
                driving_licence: shopperDetails.driving_licence || "",
            });
            setlicenceImage(shopperDetails.driving_licence || null);
        }
    }, [mode, shopperDetails]);


    const handleInputChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        const { name, value } = e.target
        setFormData((prev) => ({
            ...prev,
            [name]: value,
        }))
    }

    const handleRadioChange = (name: string, value: string) => {
        setFormData((prev) => ({
            ...prev,
            [name]: value,
        }))
    }

    const handlelicenceImageUpload = async (event: React.ChangeEvent<HTMLInputElement>) => {
        const file = event.target.files ? event.target.files[0] : null
        if (file) {
            store.dispatch(setLoadingTrue())
            try {
                // Compression options
                const options = {
                    maxSizeMB: 1,
                    maxWidthOrHeight: 1024,
                    useWebWorker: true,
                }

                const compressedFile = await imageCompression(file, options)

                // Upload compressed file
                uploadImage(compressedFile)
            } catch (error) {
                console.error("Image compression failed:", error)
            }
        }
    }

    const uploadImage = async (file: File) => {
        store.dispatch(setLoadingTrue())
        console.log("FIle", file)
        const formData = new FormData()
        formData.append("file", file)
        formData.append("fileType", "profile_pic")
        formData.append("userId", shopperDetails?.userId)

        console.log("file", file)

        try {
            const response = await CustomUploadProfilePic(formData)
            store.dispatch(setLoadingFalse())
            toast.success("File uploaded successfully")
            setlicenceImage(response.location)
        } catch (error) {
            console.error("Error uploading file:", error)
            toast.error(error)
        }
    }
    const handleSubmit = async () => {
        const payload = {
            ...formData,
            driving_licence: licenceImage,
        };

        try {
            if (mode === "add") {
                await ApicreateAirTasker(payload);
                toast.success("AirTasker created successfully");
            } else {
                await ApiupdateAirTasker({ ...payload, userId: shopperDetails.userId });
                toast.success("AirTasker updated successfully");
            }
            navigate(-1);
        } catch (error) {
            toast.error("Failed to save AirTasker");
            console.error("Error:", error);
        }
    };

    const formStyles = {
        container: {
            maxWidth: "1200px",
            margin: "0 auto",
            padding: "20px",
            fontFamily: "Arial, sans-serif",
            backgroundColor: "#fff",
        },
        section: {
            marginBottom: "30px",
            borderBottom: "1px solid #f0f0f0",
            paddingBottom: "20px",
        },
        sectionTitle: {
            fontSize: "18px",
            fontWeight: "bold",
            color: "#333",
            marginBottom: "5px",
            display: "flex",
            alignItems: "center",
        },
        sectionNumber: {
            marginRight: "8px",
        },
        sectionDescription: {
            fontSize: "14px",
            color: "#666",
            marginBottom: "15px",
        },
        formRow: {
            display: "flex",
            flexWrap: "wrap",
            margin: "0 -10px",
            marginBottom: "15px",
        },
        formColumn: {
            flex: "1 0 calc(50% - 20px)",
            margin: "0 10px",
            minWidth: "250px",
        },
        formColumnFull: {
            flex: "1 0 calc(100% - 20px)",
            margin: "0 10px",
        },
        inputLabel: {
            display: "block",
            fontSize: "14px",
            marginBottom: "5px",
            color: "#333",
        },
        requiredStar: {
            color: "red",
            marginLeft: "2px",
        },
        textField: {
            width: "100%",
            padding: "8px 12px",
            border: "1px solid #ddd",
            borderRadius: "4px",
            fontSize: "14px",
            boxSizing: "border-box",
        },
        radioGroup: {
            display: "flex",
            alignItems: "center",
            marginTop: "5px",
        },
        radioLabel: {
            marginRight: "20px",
            display: "flex",
            alignItems: "center",
            fontSize: "14px",
        },
        radioInput: {
            marginRight: "5px",
            width: "16px",
            height: "16px",
            accentColor: "#1976d2",
            cursor: "pointer",
        },
        uploadBox: {
            border: "1px dashed #ccc",
            borderRadius: "4px",
            height: "200px",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            cursor: "pointer",
            width: "50%",
            position: "relative" as const,
        },
        uploadIcon: {
            fontSize: "24px",
            color: "#666",
            marginBottom: "8px",
        },
        uploadText: {
            fontSize: "14px",
            color: "#666",
        },
        fileInput: {
            position: "absolute" as const,
            width: "100%",
            height: "100%",
            opacity: 0,
            cursor: "pointer",
        },
        buttonContainer: {
            display: "flex",
            justifyContent: "center",
            gap: "10px",
            marginTop: "20px",
        },
    };

    return (
        <Box sx={formStyles.container}>
            <Box sx={formStyles.section}>
                <Box sx={formStyles.sectionTitle}>
                    <span style={formStyles.sectionNumber}>1.</span> Personal Details
                </Box>
                <Box><span style={formStyles.sectionDescription}>Tell us a little about yourself.</span></Box>
            </Box>
            <Box sx={{ display: "flex", flexWrap: "wrap" }}>
                <Box sx={{ flex: "1 1 65%", paddingRight: "20px" }}>
                    <Box sx={formStyles.formRow}>
                        <Box sx={formStyles.formColumn}>
                            <label style={formStyles.inputLabel}>
                                First Name <span style={formStyles.requiredStar}>*</span>
                            </label>
                            <input
                                type="text"
                                name="firstName"
                                style={formStyles.textField}
                                value={formData.firstName}
                                onChange={handleInputChange}
                            />
                        </Box>
                        <Box sx={formStyles.formColumn}>
                            <label style={formStyles.inputLabel}>
                                Last Name <span style={formStyles.requiredStar}>*</span>
                            </label>
                            <input
                                type="text"
                                name="lastName"
                                style={formStyles.textField}
                                value={formData.lastName}
                                onChange={handleInputChange}
                            />
                        </Box>
                    </Box>
                    <Box sx={formStyles.formRow}>
                        <Box sx={formStyles.formColumn}>
                            <label style={formStyles.inputLabel}>
                                Email <span style={formStyles.requiredStar}>*</span>
                            </label>
                            <input
                                type="email"
                                name="emailId"
                                style={formStyles.textField}
                                value={formData.emailId}
                                onChange={handleInputChange}
                                disabled={mode === "update"}
                            />
                        </Box>
                        <Box sx={formStyles.formColumn}>
                            <label style={formStyles.inputLabel}>
                                Mobile <span style={formStyles.requiredStar}>*</span>
                            </label>
                            <input
                                type="text"
                                name="contactNo"
                                style={formStyles.textField}
                                value={formData.contactNo}
                                onChange={handleInputChange}
                            />
                        </Box>
                    </Box>
                    <Box sx={formStyles.formRow}>
                        <Box sx={formStyles.formColumn}>
                            <label style={formStyles.inputLabel}>
                                City <span style={formStyles.requiredStar}>*</span>
                            </label>
                            <input
                                type="text"
                                name="city"
                                style={formStyles.textField}
                                value={formData.city}
                                onChange={handleInputChange}
                            />
                        </Box>
                    </Box>
                    <Box sx={formStyles.formRow}>
                        <Box sx={formStyles.formColumn}>
                            <label style={formStyles.inputLabel}>
                                D.O.B <span style={formStyles.requiredStar}>*</span>
                            </label>
                            <input
                                type="date"
                                name="dob"
                                style={formStyles.textField}
                                value={formData.dob}
                                onChange={handleInputChange}
                            />
                        </Box>
                        <Box sx={formStyles.formColumn}>
                            <label style={formStyles.inputLabel}>
                                Gender <span style={formStyles.requiredStar}>*</span>
                            </label>
                            <Box sx={formStyles.radioGroup}>
                                <label style={formStyles.radioLabel}>
                                    <input
                                        type="radio"
                                        name="gender"
                                        style={formStyles.radioInput}
                                        checked={formData.gender === "Male"}
                                        onChange={() => handleRadioChange("gender", "Male")}
                                    />
                                    Male
                                </label>
                                <label style={formStyles.radioLabel}>
                                    <input
                                        type="radio"
                                        name="gender"
                                        style={formStyles.radioInput}
                                        checked={formData.gender === "Female"}
                                        onChange={() => handleRadioChange("gender", "Female")}
                                    />
                                    Female
                                </label>
                            </Box>
                        </Box>
                    </Box>
                </Box>
                <Box sx={{ flex: "1 1 35%" }}>
                    <label style={formStyles.inputLabel}>
                        Profile Image <span style={formStyles.requiredStar}>*</span>
                    </label>
                    <Box sx={formStyles.uploadBox}>
                        {licenceImage ? (
                            <img
                                src={licenceImage || "/placeholder.svg"}
                                alt="Profile"
                                style={{
                                    maxHeight: "100%",
                                    maxWidth: "100%",
                                    objectFit: "contain",
                                }}
                            />
                        ) : (
                            <>
                                <Box sx={formStyles.uploadIcon}>
                                    <Upload />
                                </Box>
                                <Box style={formStyles.uploadText}>Upload Here</Box>
                            </>
                        )}
                        <input type="file" accept="image/*" style={formStyles.fileInput} onChange={handlelicenceImageUpload} />
                    </Box>
                </Box>
            </Box>
            <Box style={formStyles.buttonContainer}>
                <Button variant="contained" className="table-row-background" onClick={handleSubmit}>
                    {mode === "add" ? "Add AirTasker" : "Update AirTasker"}
                </Button>
            </Box>
        </Box >
    )
}
export default AirTasker;